import apiBaseState from "~/constants/apiBaseState";

const getState = () => {
    return {
        communitySettingsForProject: apiBaseState(),
        updateCommunitySettingsForProject: apiBaseState(),
    };
};
export const state = () => (getState());

export const mutations = {
    RESET_STORE(state){
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    SET_GET_COMMUNITY_SETTINGS_FOR_PROJECT(state, payload){
        state.communitySettingsForProject = payload;
    },
    SET_UPDATE_COMMUNITY_SETTINGS_FOR_PROJECT(state, payload){
        state.updateCommunitySettingsForProject = payload;
    },
};

export const actions = {
    GET_COMMUNITY_SETTINGS_FOR_PROJECT(state, data) {
        const {accountSlug, projectSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/community`;
        return this.$whyApi.get({
            url,
            mutation: "community/SET_GET_COMMUNITY_SETTINGS_FOR_PROJECT",
            errorMessage: "Error getting community settings",
            notify: this.$notify
        });
    },
    UPDATE_COMMUNITY_SETTINGS_FOR_PROJECT(state, data) {
        const {accountSlug, projectSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/community`;

        return this.$whyApi.post({
            url,
            data: payload,
            handleMedia: true,
            mutation: "community/SET_UPDATE_COMMUNITY_SETTINGS_FOR_PROJECT",
            errorMessage: "Error setting community settings",
            notify: this.$notify
        });
    },
};
